<template>
    <div class="wrapper" ref="parent">
        <slot name="activator" :onActivate="onActivate"></slot>
        <div
            class="popup"
            :class="{ centered, _desktop: desktopAndMore, _tablet: tabletAndLess, _phone: phoneAndLess }"
            v-if="getActivePopupId(this.id)"
            :style="
                centered
                    ? {}
                    : {
                          top: top + 32 + 'px',
                          left: left + 'px',
                      }
            "
        >
            <div class="card" v-loading="loading" @click.stop>
                <div v-if="tabletAndLess" class="close" @click="close">
                    <font-awesome-icon class="icon" icon="times" />
                </div>
                <DatePicker v-model="date" />
                <div class="calendar-btn" @click="applyDate" :class="{ disable: !date }">Применить</div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
import moment from 'moment';

const popupsControllerGetters = ['getActivePopupId'];
const popupsControllerActions = ['openSinglePopup', 'closePopup'];

export default {
    name: 'CustomDataPicker',
    components: {
        DatePicker,
    },
    data: () => ({
        date: null,
        top: 0,
        left: 0,
        id: `f${(~~(Math.random() * 1e8)).toString(16)}`,
        parent: null,
    }),
    props: {
        centered: {
            type: Boolean,
            default: false,
        },
        loading: Boolean,
        scrollParent: null,
    },
    methods: {
        ...mapActions('popupsController', popupsControllerActions),
        updatePosition() {
            this.top = this.$refs.parent.getBoundingClientRect().top;
            this.left = this.$refs.parent.getBoundingClientRect().left - 100;
        },
        onActivate(e) {
            this.openSinglePopup({ id: this.id, e: e });
        },
        close() {
            this.closePopup(this.id);
        },
        applyDate() {
            if (!this.date) return;
            const date = moment(this.date).format();
            this.$emit('changeDate', date);
            this.$emit('on-change-date', { date, popUpId: this.id });
        },
    },
    computed: {
        ...mapGetters('popupsController', popupsControllerGetters),
        ...mapGetters(['width']),
        desktopAndMore() {
            return this.width > 768;
        },
        tabletAndLess() {
            return this.width <= 768;
        },
        phoneAndLess() {
            return this.width <= 415;
        },
    },
    watch: {
        scrollParent: {
            handler(val) {
                this.parent = val;
            },
            immediate: true,
        },
    },
    mounted() {
        window.addEventListener('scroll', this.updatePosition);
        this.parent ? this.parent.addEventListener('scroll', this.updatePosition) : null;
        this.updatePosition();
    },
    updated() {
        window.addEventListener('scroll', this.updatePosition);
        this.parent ? this.parent.addEventListener('scroll', this.updatePosition) : null;
        this.updatePosition();
    },
    destroyed() {
        window.removeEventListener('scroll', this.updatePosition);
        this.parent.removeEventListener('scroll', this.updatePosition);
    },
};
</script>

<style lang="scss">
.is-not-in-month {
    display: none;
}
</style>
<style lang="scss" scoped>
@import '~@/styles/rem';
.popup {
    position: fixed;
    z-index: 9999;
    top: 32px;
    left: 0;

    .card {
        background: #ffffff;
        box-shadow: 0 2px 12px rgba(107, 116, 123, 0.25);
        border-radius: 4px;
        padding: 32px;
        margin-bottom: 32px;
        position: relative;
        .close {
            position: absolute;
            top: rem(10);
            right: rem(10);
            border-radius: 50%;
            background: white;
            box-shadow: 0 rem(6) rem(10) rgba(131, 134, 163, 0.12);
            width: rem(30);
            height: rem(30);
            font-size: rem(15);
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            color: grey;
            cursor: pointer;

            @include on-md {
                top: mdrem(5);
                right: mdrem(5);
                box-shadow: 0 rem(3) rem(5) rgba(131, 134, 163, 0.12);
                width: mdrem(25);
                height: mdrem(25);
                font-size: mdrem(15);
            }
            @include on-sm {
                top: smrem(5);
                right: smrem(5);
                box-shadow: 0 rem(3) rem(5) rgba(131, 134, 163, 0.12);
                width: smrem(25);
                height: smrem(25);
                font-size: smrem(15);
            }
            @include on-xs {
                top: xsrem(5);
                right: xsrem(5);
                box-shadow: 0 rem(3) rem(5) rgba(131, 134, 163, 0.12);
                width: xsrem(40);
                height: xsrem(40);
                font-size: xsrem(15);
            }
        }
    }

    &._phone {
        left: 0 !important;
        right: 0 !important;
        bottom: 0 !important;
        box-shadow: 0px -4px 12px rgba(107, 116, 123, 0.25);
        border-radius: 12px 12px 0 0;
        .card {
            .vc-container {
                //margin: 0 auto 12px;
            }
            .calendar-btn {
                border-radius: 0;
            }
        }
    }

    &.centered {
        top: 0;
        height: 100%;
        width: 100%;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(1, 1, 1, 0.07);
    }

    .calendar-btn {
        box-sizing: border-box;
        border: 2px solid #4663ab;
        background: #4663ab;
        border-radius: 4px;
        width: 100%;
        font-style: normal;
        font-weight: bold;
        font-size: 18px;
        line-height: 26px;
        text-align: center;
        color: #ffffff;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        height: 48px;
        cursor: pointer;

        &:hover {
            background-color: #356ed5;
        }

        &.disable {
            border: 2px solid #c3d5f6;
            color: #9fb7e3;
            background-color: #eff3fb;
            cursor: not-allowed;
        }
    }
}
</style>

<style lang="scss">
.vc-container {
    border: none !important;
    font-family: 'Open Sans', sans-serif !important;
    font-size: 16px !important;

    & * {
        font-family: 'Open Sans', sans-serif !important;
        font-size: 16px !important;
    }
}
</style>
